<template>
    <div>
        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'信息获取详情'}]"/>
        <div class="bigDiv">
            <div class="h-piece">
                <div class="top">
                    <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                        <h1>需求信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine quqiu">
                            <el-form
                                    :model="f" label-position="right"
                                    ref="f"
                                    :rules="rules"
                                    :inline="true"
                                    class="demo-ruleForm h-formbLine">
                                <el-form-item
                                        label="拜访时间"
                                        class="h-elformWrap-2"
                                        v-if="showCare"
                                        readonly>
                                    <el-input
                                            v-model="f.userCare.cdate"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="客户类型" class="h-elformWrap-2" prop="euType">
                                    <el-select v-model="f.euType" :v="f.euType" placeholder="请选择"
                                               @change="customerType">
                                        <el-option v-for="(item) in options2"
                                                   :key="item.code"
                                                   :label="item.name"
                                                   :value="item.code"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户全称" class="h-elformWrap-2" prop="euName">
                                    <el-select v-model="f.euName" :v="f.euName" filterable remote placeholder="请输入"
                                               :remote-method="showFormList" @change="showForm">
                                        <el-option v-for="(item) in EuName"
                                                   :key="item.id"
                                                   :label="item.userName"
                                                   :value="item.userName">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode"
                                              v-if="customer.areaCode">
                                    <el-input
                                            v-model="customer.areaCode"
                                            :v="customer.areaCode"
                                            placeholder="自带出"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode"
                                              v-if="customer.channelCode">
                                    <el-input
                                            v-model="customer.channelCode"
                                            :v="customer.channelCode"
                                            placeholder="自带出"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="部门科室" class="h-elformWrap-2" prop="department">
                                    <el-input v-model="f.department"></el-input>
                                </el-form-item>
                                <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                                    <el-input v-model="f.contactuserName"></el-input>
                                </el-form-item>
                                <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                                    <el-input v-model="f.telephone"
                                              oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                                </el-form-item>
                                <el-form-item label="需求分类" class="h-elformWrap-2">
                                    <el-input value="信息获取" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="预计投标日期" class="h-elformWrap-2" prop="bidConvDate">
                                    <el-date-picker
                                            type="date"
                                            placeholder="选择时间"
                                            value-format="yyyy-MM-dd"
                                            v-model="f.bidConvDate"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="预计成单日期" class="h-elformWrap-2" prop="expConvDate">
                                    <el-date-picker
                                            type="date"
                                            placeholder="选择时间"
                                            value-format="yyyy-MM-dd"
                                            v-model="f.expConvDate"
                                            :picker-options="pickerOptions">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="中标概率" class="h-elformWrap-2" prop="bidPercentage">
                                    <brselect category="xuqiu_zbgl" :v="f.bidPercentage" v-model="f.bidPercentage" :clearable="true"
                                              />
                                </el-form-item>
                                <el-form-item
                                        label="拜访目的"
                                        class="h-elformWrap-2"
                                        prop="formCon10"
                                        v-if="showCare"
                                >
                                    <el-input
                                            v-model="f.userCare.planRemark"
                                            :v="f.userCare.planRemark"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                        label="拜访结果"
                                        class="h-elformWrap-2"
                                        prop="formCon11"
                                        v-if="showCare"
                                >
                                    <el-input
                                            v-model="f.userCare.result"
                                            :v="f.userCare.result"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="需求说明" class="h-elformWrap-1 ljjforms" prop="content">
                                    <el-input style="width: 13.65rem;" v-model="f.content" maxlength="70"
                                              placeholder="请填写"></el-input>
                                </el-form-item>
                                <div class="Yong ljjtablepaddingsxuqiude">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                                        <h1>用户在用产品信息</h1>
                                    </div>
                                    <el-form-item
                                            class="h-elformWrap-1 "
                                            style="margin-bottom:0.2rem">
                                        <div class="categoryBox">
                                            <div class="category"
                                                 :class="{'active':item==categorys}"
                                                 @click="selectC(item)"
                                                 v-for="(item,index) in category"
                                                 :key="index"
                                            >
                                                {{item}}
                                            </div>
                                        </div>
                                        <div v-if="categorys == '海尔产品'" style="margin-top:20px;">
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="productList"
                                                    :border="true"
                                            >
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="category"
                                                        label="产品大类"
                                                        width="150">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.category"
                                                                   placeholder="--请选择--"
                                                                   filterable
                                                                   @change="changeBigHaierBig(scope.row,scope.$index)"
                                                        >
                                                            <el-option
                                                                    v-for="(item,index) in LevelName"
                                                                    :key="index"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specification"
                                                        label="产品型号"
                                                        min-width="150">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.specification"
                                                                   placeholder="--请选择--"
                                                                   filterable

                                                        >
                                                            <el-option
                                                                    v-for="(item,index2) in Model[scope.$index]"
                                                                    :key="index2"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="amount"
                                                        label="产品数量"
                                                        width="100">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model.number="scope.row.amount"
                                                                placeholder="数量"
                                                                maxlength="10"
                                                                class="h-tableInput"

                                                                oninput="value=value.replace(/[^\d]/g, '')"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="barCode"
                                                        label="条形码"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.barCode"
                                                                class="h-tableInput"

                                                                placeholder="条形码">
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isOverdue"
                                                        label="是否超限期使用"
                                                        width="150">
                                                    <template scope="scope">
                                                        <brselect
                                                                category="isOverdue"
                                                                :v="scope.row.isOverdue"
                                                                v-model="scope.row.isOverdue"
                                                                class="h-tableInput"

                                                                placeholder="--请选择--">
                                                        </brselect>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="exfactoryDate"
                                                        label="出厂日期"
                                                        class="h-tableInput"
                                                        width="180">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.exfactoryDate"
                                                                type="date"
                                                                value-format="yyyy-MM-dd"
                                                                class="h-tableInput"

                                                                @change="dateChange1">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="purchaseDate"
                                                        label="购买日期"
                                                        class="h-tableInput"
                                                        width="180">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.purchaseDate"
                                                                type="date"
                                                                value-format="yyyy-MM-dd"
                                                                class="h-tableInput"

                                                                @change="dateChange2">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="产品照片"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <brupload
                                                                :refid=scope.row.id
                                                                :reftype=jingpinHaier
                                                                :showtime="showtime"
                                                                uploadflag
                                                                delflag
                                                        >
                                                            <el-button size="small" type="text">上传</el-button>
                                                        </brupload>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        label="备注"
                                                        class="h-tableInput"
                                                        width="180">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.remark"
                                                                class="h-tableInput"

                                                                placeholder="备注">
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="操作" fixed="right">
                                                    <template slot-scope="scope">
                                                        <el-button type="text" size="small"
                                                                   class="h-tableLink h-btn"
                                                                   @click="delPlan(scope.$index)">删除
                                                        </el-button>
														<!-- <div class="l-operationBox">
															<span class="l-operationlist br-operation-delete" title="删除" @click="delPlan(scope.$index)"></span>
														</div> -->
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div v-if="categorys == '竞品'" style="margin-top:20px;">
                                            <el-table
                                                    ref="multipleTable"
                                                    :data="jingpinList"
                                                    :border="true"
                                                    style="width: 100%"
                                            >
                                                <el-table-column
                                                        type="index"
                                                        width="40"
                                                        label="#">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="category"
                                                        label="产品大类"
                                                        width="170">
                                                    <template scope="scope">
                                                        <el-select v-model="scope.row.category"
                                                                   placeholder="请选择">
                                                            <el-option
                                                                    v-for="(item) in LevelName"
                                                                    :key="item.id"
                                                                    class="h-tableInput"
                                                                    :label="item.levelname"
                                                                    :value="item.id">
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="specification"
                                                        label="产品型号"
                                                        min-width="180">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.specification"
                                                                placeholder="产品型号"
                                                                class="h-tableInput"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="amount"
                                                        label="产品数量"
                                                        width="100">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model.number="scope.row.amount"
                                                                placeholder="产品数量"
                                                                maxlength="10"
                                                                class="h-tableInput"
                                                                oninput="value=value.replace(/[^\d]/g, '')"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="barCode"
                                                        label="条形码"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.barCode"
                                                                placeholder="条形码"
                                                                class="h-tableInput"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="isOverdue"
                                                        label="是否超限期使用"
                                                        width="150">
                                                    <template scope="scope">
                                                        <brselect
                                                                category="isOverdue"
                                                                :v="scope.row.isOverdue"
                                                                v-model="scope.row.isOverdue"
                                                                placeholder="--请选择--"
                                                                class="h-tableInput"
                                                        >
                                                        </brselect>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="exfactoryDate"
                                                        label="出厂日期"
                                                        width="180">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.exfactoryDate"
                                                                type="date"
                                                                class="h-tableInput"
                                                                value-format="yyyy-MM-dd"
                                                                @change="dateChange1">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="purchaseDate"
                                                        label="购买日期"
                                                        width="180">
                                                    <template scope="scope">
                                                        <el-date-picker
                                                                v-model="scope.row.purchaseDate"
                                                                type="date"
                                                                class="h-tableInput"
                                                                value-format="yyyy-MM-dd"
                                                                @change="dateChange2">
                                                        </el-date-picker>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        label="产品照片"
                                                        width="150">
                                                    <template slot-scope="scope">
                                                        <brupload
                                                                :refid=scope.row.id
                                                                :reftype=jingpinOther
                                                                :showtime="showtime"
                                                                uploadflag
                                                                delflag
                                                        >
                                                            <el-button size="small" type="text">上传</el-button>
                                                        </brupload>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="remark"
                                                        label="备注" width="180">
                                                    <template slot-scope="scope">
                                                        <el-input
                                                                v-model="scope.row.remark"
                                                                placeholder="备注"
                                                                class="h-tableInput"
                                                        >
                                                        </el-input>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="操作" fixed="right">
                                                    <template slot-scope="scope">
                                                        <el-button type="text" size="small"
                                                                   class="h-tableLink h-btn"
                                                                   @click="delPlan(scope.$index)">删除
                                                        </el-button>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div class="h-tableAdd" @click="add">
                                            <a>新增一行</a>
                                        </div>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="h-pieceIn2">
                    <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
                        <h1>产品信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formLine quqiu">
                            <el-form
                                    :model="f"
                                    :rules="rules"
                                    label-position="right"
                                    ref="f"
                                    :inline="true"
                                    class="demo-ruleForm h-formbLine">
                                <el-form-item label="产品大类" class="h-elformWrap-2" prop="detail.proCode">
                                    <el-select
                                            v-model="f.detail.proCode"
                                            placeholder="请选择"
                                            @change="selectproModel(f.detail.proCode)">
                                        <el-option
                                                v-for="(item) in LevelName"
                                                :key="item.id"
                                                :label="item.levelname"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="产品型号" class="h-elformWrap-2" prop="detail.proModel">
                                    <el-select
                                            v-model="f.detail.proModel"
                                            placeholder="请选择">
                                        <el-option
                                                v-for="(item) in ProModel"
                                                :key="item.id"
                                                :label="item.levelname"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="数量(台)" class="h-elformWrap-2" prop="detail.proNumber">
                                    <el-input
                                            v-model.number="f.detail.proNumber"
                                            maxlength="10" oninput="value=value.replace(/[^\d]/g, '')" @change="totalprice"
                                            placeholder="请输入正整数">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label=产品单价 class="h-elformWrap-2" prop="detail.proPrice">
                                    <el-input v-model="f.detail.proPrice" :v="f.detail.proPrice"
                                              placeholder="请输入正整数" maxlength="8"
                                              @change="totalprice"></el-input>
                                </el-form-item>
                                <el-form-item label=产品总额 class="h-elformWrap-2" prop="detail.proTotalAmount">
                                    <el-input
                                            v-model="f.detail.proTotalAmount"
                                            :v="f.detail.proTotalAmount"
                                            readonly>
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite"  @click="backL">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveDetail()">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                showUserCare:false,
                EuName:[],
                showtime: false,
                jingpinOther: "竞品拍摄",
                jingpinHaier: "海尔拍摄",
                day1: "",
                day2: "",
                LevelName: [],
                ProModel: [],
                //竞品信息-产品型号
                Model: [{}],
                showCare: false,
                cg: null,
                category: ['海尔产品', '竞品'],
                productList: [{type: "1", fromType: '31',specification:'',id: this.getUUid()}],
                jingpinList: [{type: "2", fromType: '31',id: this.getUUid()}],
                categorys: '海尔产品',
                tableList: [],
                tableDate: [],
                p1: null,
                p2: null,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                customer: {
                    areaCode: null,
                    channelCode: null,
                },
                //带线表单
                f: {
                    productInfoList: [],
                    id: '',
                    date1: '',
                    date2: '',
                    euName: '',
                    demandType: '',
                    userCode: '',
                    content: '',
                    euCode: '',
                    euType: null,
                    bidConvDate: '',
                    expConvDate: '',
                    bidPercentage: '',
                    areaCode: null,
                    channelCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    userCare: {
                        result: null,
                        cdate: null,
                        planRemark: null
                    },
                    detail: {
                        proCode: '',
                        proModel: '',
                        proNumber: '',
                        proPrice: '',
                        proTotalAmount: '',
                    },
                    proMain: {
                        isSuccess: null,
                        projectName: '',
                    },
                },
                rules: {
                    euType: [{required: true, message: '请选择客户类型', trigger: 'change'}],
                    euName: [{required: true, message: '请选择客户全称', trigger: 'change'}],
                    department: [{required: true, message: '请填写部门/科室', trigger: 'change'}],
                    contactuserName: [{required: true, message: '请填写联系人', trigger: 'change'}],
                    telephone: [{required: true, message: '请填写联系电话', trigger: 'change'}],
                    "detail.proCode": [{required: true, message: '请选择产品大类', trigger: 'blur'}],
                    "detail.proModel": [{required: true, message: '请选择产品型号', trigger: 'blur'}],
                    "detail.proNumber": [{required: true, message: '请填写需求数量', trigger: 'blur'}],
                    "detail.proPrice": [{required: true, message: '请填写产品单价', trigger: 'blur'},
                        {validator: (rule, value, callback) => {
                                if (/^\d+.\d+$/.test(value) == false) {
                                    callback(new Error("只能写浮点数"));
                                } else {
                                    callback();
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    content: [{required: true, message: '请输入需求说明', trigger: 'blur'}],
                   /* bidConvDate:[{required:true,message:'请选择预计投标日期',trigger:'change'}],
                    expConvDate:[{required:true,message:'请选择预计成单日期',trigger:'change'}],
                    bidPercentage:[{required:true,message:'请填写中标',trigger:'blur'}],*/
                }
            }
        },
        methods: {
            customerType() {
                this.f.euName = null;
                this.customer.channelCode = null;
                this.f.contactuserName = null;
                this.f.department = null;
                this.f.telephone = null;
                this.customer.areaCode = null;
                this.EuName=null;
            },
            //通过用户名带出详细信息
            showFormList(value) {
                this.f.userName = value;
                if (this.f.euType == 1) {
                    ss.UserCare.agentOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                } else if (this.f.euType == 2) {
                    ss.UserCare.customerOption(this.f).then(rd => {
                        this.EuName = rd;
                    })
                }
            },
            showForm() {
                for (var i = 0; i < this.EuName.length; i++) {
                    if (this.f.euName == this.EuName[i].userName) {
                        this.f.euCode = this.EuName[i].userCode;
                        this.f.areaCode = this.EuName[i].areaCode;
                        this.f.channelCode = this.EuName[i].channelCode;
                        this.customer.areaCode = this.$getDictName("YLRegion", this.EuName[i].areaCode);
                        this.customer.channelCode = this.$getDictName("sales_region", this.EuName[i].channelCode);
                        this.f.contactuserName = this.EuName[i].contactuserName;
                        this.f.department = this.EuName[i].department;
                        this.f.telephone = this.EuName[i].telephone;
                    }
                }
            },
            totalprice(){
                if(this.f.detail.proNumber!=null && this.f.detail.proPrice!=null){
                    this.f.detail.proTotalAmount = this.f.detail.proNumber * this.f.detail.proPrice;
                }
            },
            selectC(item) {
                this.categorys = item;
            },
            //产品大类初始化
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //大类选择-大类修改时，当块数据proProduct[i]-v,index-i
            changeBigHaierBig(v,i){
                v.specification='';
                this.selectProductHaier(v.category,i);
            },
            //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
            selectProductHaier(v,i) {
                ss.ProService.product2Select(v).then(rd => {
                    this.Model[i] = rd;
                    this.$set(this.Model,i,rd);
                })
            },
            //产品信息-产品型号
            selectproModel(value) {
                this.f.detail.proModel = '';
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            showproModel(value) {
                ss.UserDemand.showproModel(value).then(rd => {
                    this.ProModel = rd;
                })
            },
            showAllproModel() {
                ss.UserDemand.showAllproModel().then(rd => {
                    this.Model = rd;
                })
            },
            dateChange1(val) {
                console.log(val);
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day1 = date.getTime();
                if (this.day2 < this.day1) {
                    if (this.day2 == 0) {
                        return;
                    }
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.f.purchaseDate = "";
                }
            },
            dateChange2(val) {
                console.log(val);
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day2 = date.getTime()
                if (this.day2 < this.day1) {
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.f.purchaseDate = "";
                }
            },
            query() {
                if(this.$route.query.id!=null){
                    this.f.id = this.$route.query.id;
                    ss.UserDemand.demandDetail2(this.f.id).then(rd => {
                        this.f = rd;
                        if(this.f.cid!='' && this.f.cid!=null){
                            this.showCare = true;
                        }
                        this.showproModel(rd.detail.proCode);
                        this.f.euType = this.$getDictName("userCareType", rd.euType);
                        this.customer.areaCode = this.$getDictName("YLRegion", rd.customer.areaCode);
                        this.customer.channelCode = this.$getDictName("sales_region", rd.customer.channelCode);
                        rd.productInfoList.forEach((item,index)=>{
                            if (item.type == "1") {
                                this.productList.push(item);
                            } else if (item.type == "2") {
                                this.jingpinList.push(item);
                            }
                        });
                        if (this.productList.length > 1) {
                            this.productList.splice(0, 1);
                        }
                        if (this.jingpinList.length > 1) {
                            this.jingpinList.splice(0, 1);
                        }
                        this.productList.forEach((item,index)=>{
                            this.selectProductHaier(item.category,index);
                        })
                        if (this.f.proMain) {
                            this.f.proMain.isSuccess = this.$getDictName("pro_success", rd.proMain.isSuccess);
                            if (rd.proMain.isSuccess != null) {
                                this.f.proMain.isSuccess = this.$getDictName("pro_success", rd.proMain.isSuccess);
                            }
                        }
                    })
                }
            },
            getUUid() {
                return  this.$util.getUuid();
            },
            add() {
                var list = {
                    id: this.getUUid(),
                    category: '',
                    specification: '',
                    amount: '',
                    barCode: '',
                    exfactoryDate: '',
                    purchaseDate: '',
                    remark: '',
                    type: '',
                    fromType: '',
                    fromId: '',
                }
                if (this.categorys == '海尔产品') {
                    list.type = "1";
                    list.fromType = '31';
                    this.productList.push(list);
                } else if (this.categorys == '竞品') {
                    list.type = "2";
                    list.fromType = '31';
                    this.jingpinList.push(list);
                }
            },
            delPlan(index) {
                if (this.categorys == '海尔产品') {
                    this.productList.splice(index, 1);
                } else if (this.categorys == '竞品') {
                    this.jingpinList.splice(index, 1);
                }
            },
            saveDetail() {
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.$msg.confirm("确认提交该信息获取?", () => {
                        if(this.$route.query.id!=null){
                            this.f.id = this.$route.query.id;
                        }
                        this.f.demandType = 2;
                        if (this.f.euType == "经销商") {
                            this.f.euType = 1;
                        } else if (this.f.euType == "用户") {
                            this.f.euType = 2;
                        }
                        this.f.productInfoList=[];
                        for (var i = 0; i < this.productList.length; i++) {
                            if (this.productList[i].category != null && this.productList[i].specification != null) {
                                this.productList[i].fromId = this.f.id;
                                this.f.productInfoList.push(this.productList[i]);
                            }
                        }
                        for (var i = 0; i < this.jingpinList.length; i++) {
                            if (this.jingpinList[i].category != null && this.jingpinList[i].specification != null) {
                                this.jingpinList[i].fromId = this.f.id;
                                this.f.productInfoList.push(this.jingpinList[i]);
                            }
                        }
                        ss.UserDemand.saveDetail(this.f).then(rd => {
                            this.$msg.msgs("操作成功");
                            this.$router.go(-1);
                        });
                    });
                }
            },
            backL() {
                this.$router.go(-1);
            },

            delIndex(index) {
                this.proProduct.splice(index, 1)
                //console.log(index,"删除一行数据");
            },
        },
        created() {
            this.options2 = this.$store.getters.dicts["userCareType"];
            this.customerType();
            this.query();
            this.showLevelName();
            this.showAllproModel();
        }
    }
</script>

<style scoped>
    .categoryBox {
        display: flex;
        border-bottom: 1px solid #dcdfe1;
    }

    .bigDiv {
        margin: 20px;
    }

    .categoryBox .category {
        width: 122px;
        height: 36px;
        color: #b0b0b0;
        font-size: 0.16rem;
        text-align: center;
        line-height: 36px;
        margin-left: 20px;
        border: 1px solid #b4b4b4;
        cursor: pointer;
        border-bottom: 0;
    }

    .categoryBox .category:first-child {
        margin-left: 0;
    }

    .categoryBox .category.active {
        color: #fff;
        border: 1px solid #1b78e6;
        background: #1b78e6;
    }

    .quqiu {
        margin-top: 0.38rem
    }
</style>
<style>
    .quqiu .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .quqiu .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .quqiu .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .quqiu .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .quqiu .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
        margin-bottom: 20px;
    }

    .quqiu .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 100%;
    }
    .quqiu .h-formbLine .h-elformWrap-1.ljjforms .el-form-item__content{
        width: 80.3%;
    }
    .h-piece .top .h-formbLine .Yong .el-form-item__content .el-input__inner {
        border-bottom: none;
        text-align: center;
    }

    .h-piece .top .h-formbLine .Yong .el-form-item__content .el-input__inner:focus {
        border: 1px solid #2785e7;
        box-shadow: 0 0 0.16rem rgba(39, 133, 231, 0.35) inset;
        border-radius: 4px;
        height: 40px;
    }
	.ljjtablepaddingsxuqiude .h-tableInput .el-input__inner{
		padding: 0 0.1rem;
	}
	.ljjtablepaddingsxuqiude .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
